var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.002,
    height: 40,
    viewBox: "0 0 40.002 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Profile",
    "data-name": "User Profile",
    transform: "translate(332 7650)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-332 -7650)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "User_Profile-2",
    "data-name": "User Profile",
    transform: "translate(-332 -7650.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Zm0,5.98A6.615,6.615,0,1,1,13.386,12.6,6.616,6.616,0,0,1,20,5.981Zm0,28.791a14.679,14.679,0,0,1-9.559-3.525A2.819,2.819,0,0,1,9.449,29.1a6.672,6.672,0,0,1,6.7-6.67h7.7a6.662,6.662,0,0,1,6.694,6.67,2.812,2.812,0,0,1-.988,2.142A14.673,14.673,0,0,1,20,34.772Z",
    transform: "translate(0 0)",
    fill: "#438afb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.80b1310a33c817164372f91915e74c27.svg";
export { ForwardRef as ReactComponent };